import useSWR from "swr";

import { ApiProfile } from "../types";

export default function useAccountChildren() {
  const { data, error, isValidating } = useSWR<ApiProfile[]>(
    `/profiles/me/children`
  );
  return {
    children: data,
    error,
    isValidating,
  };
}
